/**
 * DOM 判断是 b 否为 a 的子元素
 */
export const fixContains = (a, b) => {
    try {
        while ((b = b.parentNode)) {
            if (b === a) {
                return true;
            }
        }
        return false;
    } catch (error) {
        return false;
    }
};
